import { css } from '@emotion/react'
import { getPeriodFilterText } from 'components/filteritem/utils-filterItem'
import { FilterTag } from 'components/filtertags'
import { isUndefinedOrNull } from 'util/checks'

import { listaAtendimentoStylesRecord } from '../listaAtendimentoStyles'
import { ListaAtendimentoFilterPopperFormModel } from './ListaAtendimentoFilterPopperForm'
import { ListaAtendimentoFilterModel, ListaAtendimentoFilterPopperModel } from './model'

export function getListaAtendimentoFilterTags(
  filtros: ListaAtendimentoFilterModel,
  now: Date,
  isUpa: boolean
): FilterTag[] {
  const filterTags: FilterTag[] = []

  if (filtros.statusAtendimento?.length) {
    const statusAtendimentoText = filtros.statusAtendimento
      .map((item) => listaAtendimentoStylesRecord[item].descricao)
      .join(', ')

    filterTags.push(['Status do atendimento', statusAtendimentoText])
  }

  const isPeriodoFilled =
    !isUndefinedOrNull(filtros?.periodo?.startDate) && !isUndefinedOrNull(filtros?.periodo?.endDate)
  const showPeriodo = (!filtros.isSomenteNaoFinalizados && isPeriodoFilled) || (isUpa && filtros.isPeriodo24h)

  if (showPeriodo) {
    const periodoText = isUpa && filtros.isPeriodo24h ? 'Últimas 24h' : getPeriodFilterText(filtros.periodo, now)!

    filterTags.push([
      'Período',
      periodoText,
      css`
        overflow: visible;
      `,
    ])
  }

  if (filtros.isSomenteNaoFinalizados) {
    filterTags.push([
      '',
      'Somente atendimentos não finalizados',
      css`
        overflow: visible;
        font-weight: bold;
      `,
    ])
  }

  if (filtros.tiposServico?.length) {
    const tiposServicoText = filtros.tiposServico.map((item) => item.nome.toUpperCase()).join(', ')

    filterTags.push(['Tipo de serviço', tiposServicoText])
  }

  if (filtros.equipes?.length) {
    const equipesText = filtros.equipes.map((item) => item.nome).join(', ')

    filterTags.push(['Equipe', equipesText])
  }

  if (filtros.responsaveis?.length) {
    const responsaveisText = filtros.responsaveis.map((item) => item?.profissional.nome).join(', ')

    filterTags.push(['Profissionais', responsaveisText])
  }

  return filterTags
}

export function getListaAtendimentoFilterPeriodoDate(
  date: Instant,
  isSomenteNaoFinalizados: boolean,
  isPeriodo24h: boolean
): Date | undefined {
  if (isSomenteNaoFinalizados || isPeriodo24h || isUndefinedOrNull(date)) {
    return undefined
  }

  return new Date(date)
}

export function createListaAtendimentoFilterInitialValues(
  values: ListaAtendimentoFilterPopperModel
): ListaAtendimentoFilterPopperFormModel {
  const isSomenteNaoFinalizados = values.isSomenteNaoFinalizados ?? false
  const isPeriodo24h = values.isPeriodo24h ?? false

  const startDate = getListaAtendimentoFilterPeriodoDate(
    values.periodo.startDate,
    isSomenteNaoFinalizados,
    isPeriodo24h
  )

  const endDate = getListaAtendimentoFilterPeriodoDate(values.periodo.endDate, isSomenteNaoFinalizados, isPeriodo24h)

  return {
    ...values,
    periodo: {
      startDate,
      endDate,
    },
  }
}
